
import SuluContent from '../content.vue';

export default {
  name: 'sulu-template-headless',
  components: {SuluContent},
  props: {
    sulu: {
      type: Object,
      required: true,
    },
  },
};
